import React, { useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface LifetimePartnerFormProps {
  onSuccess?: (reference: string) => void;
}
export const LifetimePartnerForm: React.FC<LifetimePartnerFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    sex: '',
    phone: '',
    location: '',
    industry: '',
    occupation: '',
    commitment: '',
    mediaConsent: '',
    comments: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Check if required fields are complete
    setTimeout(() => {
      const requiredFields = ['email', 'fullName', 'sex', 'phone', 'location', 'industry', 'occupation', 'commitment', 'mediaConsent'];
      const isComplete = requiredFields.every(field => formData[field]);
      setIsFormComplete(isComplete && formData.email.includes('@'));
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-798">
      <div className="mb-6" data-id="element-799">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-800">
          Lifetime Partner Access
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-801">
          Join The Networking Salon as a Lifetime Partner for ₦50,000
          (Discounted from ₦100,000)
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-802">
        <div data-id="element-803">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-804">
            Email <span className="text-gray-500" data-id="element-805">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your email address" required data-id="element-806" />
        </div>
        <div data-id="element-807">
          <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-808">
            Full Name <span className="text-gray-500" data-id="element-809">(required)</span>
          </label>
          <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your full name" required data-id="element-810" />
        </div>
        <div data-id="element-811">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-812">
            Sex <span className="text-gray-500" data-id="element-813">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-814">
            {['Male', 'Female'].map(option => <div key={option} className="flex items-center" data-id="element-815">
                <input type="radio" id={`sex-${option}`} name="sex" value={option} checked={formData.sex === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-816" />
                <label htmlFor={`sex-${option}`} className="text-gray-700" data-id="element-817">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-818">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-819">
            Phone Number <span className="text-gray-500" data-id="element-820">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your phone number" required data-id="element-821" />
        </div>
        <div data-id="element-822">
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-823">
            City of Residence <span className="text-gray-500" data-id="element-824">(required)</span>
          </label>
          <select id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md" data-id="element-825">
            <option value="" data-id="element-826">Select your city</option>
            <option value="Houston Texas" data-id="element-827">Houston Texas</option>
            <option value="Lagos" data-id="element-828">Lagos</option>
            <option value="Abuja" data-id="element-829">Abuja</option>
            <option value="Benin City" data-id="element-830">Benin City</option>
            <option value="Warri" data-id="element-831">Warri</option>
            <option value="Berlin" data-id="element-832">Berlin</option>
            <option value="Port Harcourt" data-id="element-833">Port Harcourt</option>
            <option value="UK" data-id="element-834">UK</option>
            <option value="Other" data-id="element-835">Other</option>
          </select>
        </div>
        <div data-id="element-836">
          <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-837">
            Industry <span className="text-gray-500" data-id="element-838">(required)</span>
          </label>
          <input type="text" id="industry" name="industry" value={formData.industry} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your industry" required data-id="element-839" />
        </div>
        <div data-id="element-840">
          <label htmlFor="occupation" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-841">
            What do you do? <span className="text-gray-500" data-id="element-842">(required)</span>
          </label>
          <textarea id="occupation" name="occupation" value={formData.occupation} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Describe your occupation or role" required data-id="element-843" />
        </div>
        <div data-id="element-844">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-845">
            Are you committed to actively participating in the ways described
            above? <span className="text-gray-500" data-id="element-846">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-847">
            {['Yes', 'No', 'I have questions'].map(option => <div key={option} className="flex items-center" data-id="element-848">
                <input type="radio" id={`commitment-${option}`} name="commitment" value={option} checked={formData.commitment === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-849" />
                <label htmlFor={`commitment-${option}`} className="text-gray-700" data-id="element-850">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-851">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-852">
            Are you okay with your pictures and videos of you taken at our
            events (in-person or online) be used for promotional purposes?{' '}
            <span className="text-gray-500" data-id="element-853">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-854">
            {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-855">
                <input type="radio" id={`mediaConsent-${option}`} name="mediaConsent" value={option} checked={formData.mediaConsent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-856" />
                <label htmlFor={`mediaConsent-${option}`} className="text-gray-700" data-id="element-857">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-858">
          <label htmlFor="comments" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-859">
            Additional Comments or Suggestions (You can ask your questions
            here): <span className="text-gray-500" data-id="element-860">(optional)</span>
          </label>
          <textarea id="comments" name="comments" value={formData.comments} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter any additional comments or questions" data-id="element-861" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={50000} email={formData.email} name={formData.fullName} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData
    }} data-id="element-862" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-863">
          Complete all required fields to proceed
        </button>}
    </div>;
};